import {pickBy} from 'lodash'
import BaseService from './BaseService'

class OpportunityService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  create = (data: { [key: string]: any }) =>
    this.requests.post(`/`, data)
  read = (id: string) =>
    this.requests.get(`/${id}`)
  update = (id: string, data: { [key: string]: any }) =>
    this.requests.put(`/${id}`, data)
  delete = (id: string) =>
    this.requests.delete(`/${id}`)
  export = (queryData: { [key: string]: any }) =>{
    const url = pickBy(queryData, v => v !== null && v !== undefined && v !== '' )
    return this.requests.get(`/export?${Object.keys(url).map(key => key + '=' + url[key]).join('&')}`)
  }
  search = (queryData: { [key: string]: any }) =>{
    const url = pickBy(queryData, v => v !== null && v !== undefined && v !== '' )
    return this.requests.get(`/search?${Object.keys(url).map(key => key + '=' + url[key]).join('&')}`)
  }
  restoreOpportunity = (id: string, forceRestore:boolean) =>
    this.requests.put(`/${id}/restore`,{forceRestore:forceRestore})

  getOpportunityPipeline = (queryData: { [key: string]: any }) =>{
    const url = pickBy(queryData, v => v !== null && v !== undefined && v !== '' )
    return this.requests.get(`/pipelines/search?${Object.keys(url).map(key => key + '=' + url[key]).join('&')}`)
  }

  getPipelines = (locationId:string) => this.requests.get(`/pipelines?locationId=${locationId}`)
  createPipeline = (data: { [key: string]: any }) => this.requests.post(`/pipelines`, data)
  updatePipeline = (id:string,data: { [key: string]: any }) => this.requests.put(`/pipelines/${id}`, data)
  deletePipeline = (id:string) => this.requests.delete(`/pipelines/${id}`)
  bulkDeleteOpportunities = (data:{pipelineId:string,locationId:string}) => this.requests.post(`/bulk/delete`,data)
}

const instance = new OpportunityService(BaseService.servicesConfig.Opportunities)

export default instance
